import React from "react";
import NewDesktopRecordviewRenderer from "./Desktop/NewDesktopRecordviewRenderer";
import MobileRenderer from "./Mobile/MobileRenderer";
import PositionedDesktopRecordview from "./Desktop/PositionedDesktopRecordview";
import PositionedMobileRecordview from "./Mobile/PositionedMobileRecordview";

const RecordsViewRenderer = ({ applicationBlockData }) => {
  if (applicationBlockData.device === "mobile") {
    if (applicationBlockData.is_positioned_block) {
      return <PositionedMobileRecordview />;
    } else {
      return <MobileRenderer />;
    }
  }
  if (applicationBlockData.device === "desktop" || applicationBlockData.device === "tablet") {
    if (applicationBlockData.is_positioned_block) {
      return <PositionedDesktopRecordview />;
    } else {
      return <NewDesktopRecordviewRenderer />;
    }
  }
};

export default RecordsViewRenderer;
